"use strict";
const form = document.querySelector(".form");
const containerWorkouts = document.querySelector(".workouts");
const inputType = document.querySelector(".form__input--type");
const inputDistance = document.querySelector(".form__input--distance");
const inputDuration = document.querySelector(".form__input--duration");
const inputCadence = document.querySelector(".form__input--cadence");
const inputElevation = document.querySelector(".form__input--elevation");
////////
///__Managing Workout Data_Creating Classes__//
class Workout {
    date = new Date();
    id = (Date.now() + "").slice(-10);
    clicks = 0;
    constructor(coordin, distance, duration){
        this.coordin = coordin; // [lat,lng]
        this.distance = distance; // in Km
        this.duration = duration; // in min
    }
    _setDescription() {
        // prettier-ignore
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        this.descripton = `${this.type[0].toUpperCase()}${this.type.slice(1)} on 
    ${months[this.date.getMonth()]} ${this.date.getDate()}
    `;
    }
    click() {
        this.clicks = this.clicks + 1;
    }
}
class Running extends Workout {
    type = "running";
    constructor(coordin, distance, duration, cadence){
        super(coordin, distance, duration);
        this.cadence = cadence;
        this.calcPace();
        this._setDescription();
    }
    calcPace() {
        // Min/km
        this.pace = this.duration / this.distance;
        return this.pace;
    }
}
class Cycling extends Workout {
    type = "cycling";
    constructor(coordin, distance, duration, elevationGain){
        super(coordin, distance, duration);
        this.elevationGain = elevationGain;
        this.calcSpeed();
        this._setDescription();
    }
    calcSpeed() {
        // km/hr
        this.speed = this.distance / (this.duration / 60);
        return this.speed;
    }
}
//////////////////////////////////////////////
//__APPLICATION ARCHITECTURE_//
///__Refactoring for Project Architecture__///
class App {
    #map;
    #mapZoomLevel = 13;
    #mapEvent;
    #workouts = [];
    constructor(){
        //Get User Position
        this._getPosition();
        //Get Data from Local Storage
        this._getLocalStorage();
        //Attached Event Handlers
        form.addEventListener("submit", this._newWorkout.bind(this));
        inputType.addEventListener("change", this._toggleElevationField);
        containerWorkouts.addEventListener("click", this._moveToPopup.bind(this));
    }
    _getPosition() {
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(this._loadMap.bind(this), function() {
            console.log("Could not get your Position");
        });
    }
    _loadMap(Position) {
        const { latitude } = Position.coords;
        const { longitude } = Position.coords;
        //console.log(`https://www.google.com/maps/@${latitude},${longitude}`);
        const coords = [
            latitude,
            longitude
        ];
        // 2) .Displaying map using leaflet library
        this.#map = L.map("map").setView(coords, this.#mapZoomLevel);
        L.tileLayer("https://tile.openstreetmap.fr/hot/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.#map);
        // 3).Displaying Map Maker(Handling clicks on map)
        this.#map.on("click", this._showForm.bind(this));
        //Data from Local storage
        this.#workouts.forEach((work)=>{
            this._renderWorkoutMarker(work);
        });
    }
    _showForm(mapE) {
        this.#mapEvent = mapE;
        form.classList.remove("hidden");
        inputDistance.focus();
    }
    _hideForm() {
        //Empty Input
        inputDistance.value = inputDuration.value = inputElevation.value = inputCadence.value = "";
        form.style.display = "none";
        form.classList.add("hidden");
        setTimeout(()=>form.style.display = "grid", 1000);
    }
    _toggleElevationField() {
        inputCadence.closest(".form__row").classList.toggle("form__row--hidden");
        inputElevation.closest(".form__row").classList.toggle("form__row--hidden");
    }
    _newWorkout(e) {
        // Checking validInput Number
        const validInputs = (...inputs)=>inputs.every((inp)=>Number.isFinite(inp));
        //Checking Positive Number
        const allPositive = (...inputs)=>inputs.every((inp)=>inp > 0);
        e.preventDefault();
        //Get Data from Form
        const type = inputType.value;
        const distance = +inputDistance.value;
        const duration = +inputDuration.value;
        const { lat, lng } = this.#mapEvent.latlng;
        let workout;
        //If workout running , create running Object
        if (type === "running") {
            const cadence = +inputCadence.value;
            //Check if data is Valid
            if (/* !Number.isFinite(distance) ||
        !Number.isFinite(duration) ||
        !Number.isFinite(cadence) */ !validInputs(distance, duration, cadence) || !allPositive(distance, duration, cadence)) return alert("Input have to be Positive Number!");
            workout = new Running([
                lat,
                lng
            ], distance, duration, cadence);
        }
        //If workout Cycling, create Cycling Object
        if (type === "cycling") {
            const elevation = +inputElevation.value;
            //Check if data is Valid
            if (!validInputs(distance, duration, elevation) || !allPositive(distance, duration)) return alert("Input have to be Positive Number!");
            workout = new Cycling([
                lat,
                lng
            ], distance, duration, elevation);
        }
        //Add New Object to Workout Array
        this.#workouts.push(workout);
        //console.log(workout);
        //Render Workout on Map as Marker
        this._renderWorkoutMarker(workout);
        //Render Workout on list
        this._renderWorkout(workout);
        // Hide form + Clear Input field
        this._hideForm();
        //Set Local Storage to all Workouts
        this._setLocalStorage();
    }
    _renderWorkoutMarker(workout) {
        //console.log(this.#mapEvent);
        L.marker(workout.coordin).addTo(this.#map).bindPopup(L.popup({
            maxWidth: 250,
            minWidth: 100,
            autoClose: false,
            closeOnClick: false,
            className: `${workout.type}-popup`
        })).setPopupContent(`${workout.type === "running" ? "\uD83C\uDFC3" : "\uD83D\uDEB4"}${workout.descripton}`).openPopup();
    }
    _renderWorkout(workout) {
        let html = `
    <li class="workout workout--${workout.type}" data-id=${workout.id}>
    <h2 class="workout__title">${workout.descripton}</h2>
    <div class="workout__details">
      <span class="workout__icon">${workout.type === "running" ? "\uD83C\uDFC3" : "\uD83D\uDEB4"}</span>
      <span class="workout__value">${workout.distance}</span>
      <span class="workout__unit">km</span>
    </div>
    <div class="workout__details">
      <span class="workout__icon">\u{23F1}</span>
      <span class="workout__value">${workout.duration}</span>
      <span class="workout__unit">min</span>
    </div>    
    `;
        if (workout.type === "running") html += `
      <div class="workout__details">
      <span class="workout__icon">\u{26A1}\u{FE0F}</span>
      <span class="workout__value">${workout.pace.toFixed(1)}</span>
      <span class="workout__unit">min/km</span>
      </div>
      <div class="workout__details">
      <span class="workout__icon">\u{1F9B6}\u{1F3FC}</span>
      <span class="workout__value">${workout.cadence}</span>
      <span class="workout__unit">spm</span>
      </div>
    </li>
        `;
        if (workout.type === "cycling") html += `
        <div class="workout__details">
        <span class="workout__icon">\u{26A1}\u{FE0F}</span>
        <span class="workout__value">${workout.speed.toFixed(1)}</span>
        <span class="workout__unit">km/h</span>
        </div>
       <div class="workout__details">
        <span class="workout__icon">\u{26F0}</span>
        <span class="workout__value">${workout.elevationGain}</span>
        <span class="workout__unit">m</span>
       </div>
       </li> 
        `;
        form.insertAdjacentHTML("afterend", html);
    }
    _moveToPopup(e) {
        const workoutEl = e.target.closest(".workout");
        //console.log(workoutEl);
        if (!workoutEl) return;
        const workout = this.#workouts.find((work)=>work.id === workoutEl.dataset.id);
        console.log(workout);
        const { coordin } = workout;
        this.#map.setView(coordin, this.#mapZoomLevel, {
            animate: true,
            pan: {
                duration: 1
            }
        });
    //Using the Public Interface
    //workout.click();
    }
    //We should not use local storage to large amount of Data
    _setLocalStorage() {
        localStorage.setItem("workouts", JSON.stringify(this.#workouts));
    }
    _getLocalStorage() {
        const data = JSON.parse(localStorage.getItem("workouts"));
        //console.log(data);
        if (!data) return;
        this.#workouts = data;
        this.#workouts.forEach((work)=>{
            this._renderWorkout(work);
        });
    }
    reset() {
        localStorage.removeItem("workouts");
        location.reload();
    }
}
/////////
const app = new App();

//# sourceMappingURL=index.13da8471.js.map
